/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import {declareLinkedEntity} from '../fw/MetaDataHelper.ts';
import * as Permission from "../util/Permission";

export default declareLinkedEntity({
    entity: "channelAddons",
    graphQL: "ChannelAddon",
    name: "Application Addon",
    defaultOrder: ['name', 'type'],
    parentRelation: "channelAddons",
    storageType: 'central',
    defaultTitle: (data) => {
        if (data['name']) {
            return data['name'];
        } else if (data['channelDef'] && data['channelDef']['name']) {
            return data['channelDef']['name'];
        }
    },
    writePermission: [
        Permission.PERM_EDIT_CHANNEL,
    ],
    fields: (types) => { return {
        id: {
            name: "Application Addon ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            compositeKey: true,
        },
        channel: {
            name: "Application",
            type: "relation",
            to: () => types['channels'],
            defaultValue: (channel) => {
                return channel['id'];
            },
            required: true,
            parent: true,
            compositeKey: true,
            hiddenCreate: true,
        },
        externalId: {
            name: "External ID",
            type: "string",
            defaultValue: "",
            filterable: true,
        },
        connectedChannel: {
            name: "Connected Application",
            type: "relation",
            to: () => types['channels'],
        },
        organisation: {
            name: "Organisation ID",
            type: "relation",
            to: () => types['organisations'],
            defaultValue: (channel) => {
                return channel['organisation_id'];
            },
            required: true,
            hiddenCreate: true,
        },
        addonDef: {
            name: "Application Addon Definition",
            to: () => types['addonDefs'],
            defaultValue: (channel) => {
                return channel['addonDef_id'];
            },
            type: "relation",
            hiddenCreate: true,
            required: true,
        },
        channelDef: {
            name: "Application Type",
            to: () => types['channelDefs'],
            type: "relation",
            required: true,
            filterable: true,
        },
        sourceDef: {
            name: "Source Definition",
            to: () => types['sourceDefs'],
            type: "relation",
            required: true,
            relativeTo: ["channelDef"],
        },
        name: {
            name: "Name",
            type: "string",
            defaultValue: ""
        },
        enabled: {
            name: "Enabled",
            type: "boolean",
            defaultValue: true,
            filterable: true,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        options: {
            name: "Options",
            type: "object",
            defaultValue: {},
        }
    }; },
    relations: (types) => { return {
        customDatas: {
            type: 'oneToMany',
            to: types['customDatas'],
            foreignKeys: [
                {
                    from: "id",
                    to: "channelAddon_id"
                },
                {
                    from: "organisation_id",
                    to: "organisation_id",
                    asFilterOnly: true,
                },
                {
                    from: "channel_id",
                    to: "channel_id",
                    asFilterOnly: true,
                }
            ],
            args: {
                key: {
                    type: 'string'
                }
            },
        }
    }; }
});
